import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext(null);

const TOKEN_KEY = 'nomedif_token';

const lireSession = () => {
  try {
    if (localStorage.getItem('nomedif_admin') === 'true') {
      return { role: 'admin', prenom: 'Admin', nom: '' };
    }
    const apprenant = JSON.parse(localStorage.getItem('nomedif_apprenant'));
    if (apprenant) return { ...apprenant, role: 'apprenant' };
    const formateur = JSON.parse(localStorage.getItem('nomedif_formateur'));
    if (formateur) return { ...formateur, role: 'formateur' };
  } catch { /* silent */ }
  return null;
};

export function AuthProvider({ children }) {
  const [user, setUser] = useState(lireSession);
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));

  const _storeToken = (t) => {
    localStorage.setItem(TOKEN_KEY, t);
    setToken(t);
  };

  const loginApprenant = useCallback((data) => {
    const { token: t, ...userData } = data;
    localStorage.setItem('nomedif_apprenant', JSON.stringify(userData));
    localStorage.setItem('nomedif_role', 'apprenant');
    localStorage.removeItem('nomedif_admin');
    localStorage.removeItem('nomedif_formateur');
    if (t) _storeToken(t);
    setUser({ ...userData, role: 'apprenant' });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loginFormateur = useCallback((data) => {
    const { token: t, ...userData } = data;
    localStorage.setItem('nomedif_formateur', JSON.stringify(userData));
    localStorage.setItem('nomedif_role', 'formateur');
    localStorage.removeItem('nomedif_admin');
    localStorage.removeItem('nomedif_apprenant');
    if (t) _storeToken(t);
    setUser({ ...userData, role: 'formateur' });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loginAdmin = useCallback((t) => {
    localStorage.setItem('nomedif_admin', 'true');
    localStorage.setItem('nomedif_role', 'admin');
    localStorage.removeItem('nomedif_apprenant');
    localStorage.removeItem('nomedif_formateur');
    if (t) _storeToken(t);
    setUser({ role: 'admin', prenom: 'Admin', nom: '' });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const logout = useCallback(() => {
    localStorage.removeItem('nomedif_apprenant');
    localStorage.removeItem('nomedif_formateur');
    localStorage.removeItem('nomedif_admin');
    localStorage.removeItem('nomedif_role');
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(null);
  }, []);

  // Convenience: returns headers object ready for fetch()
  const authHeaders = useCallback(() => ({
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }), [token]);

  return (
    <AuthContext.Provider value={{ user, token, loginApprenant, loginFormateur, loginAdmin, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
